// The module-level "which mode is the app in right now" register.
//
// This exists for exactly one reason: query keys. `src/lib/queries.ts`
// builds every mode-scoped key through a factory, and those factories
// are plain functions called from ~40 call sites that have no business
// knowing about a React context. The locale dimension solved the same
// problem the same way (`localeKey()` reads i18next's active language),
// and mode follows that precedent rather than inventing a second one.
//
// The provider is the only writer. Everything else reads.
import { MODE_CASH, type TradingMode } from "./types";

let active: TradingMode = MODE_CASH;

/**
 * The mode every mode-scoped query key and API call is currently built
 * from. Defaults to CASH before the provider mounts, so a query fired
 * during boot keys and fetches exactly as it did pre-epic.
 */
export function getActiveMode(): TradingMode {
  return active;
}

/**
 * Set by TradingModeProvider, synchronously, BEFORE it renders children
 * in the new mode. The ordering matters: a child that renders first and
 * builds its key second would key its query with the outgoing mode and
 * paint the wrong ledger's numbers.
 */
export function setActiveMode(mode: TradingMode): void {
  active = mode;
}

/** Test helper — restores the boot default between cases. */
export function resetActiveMode(): void {
  active = MODE_CASH;
}
